import { FundsStatus } from '@40seas/entities/funds';
import { EnumColor } from '@40seas/frontend/common/providers';

export const fundsStatusColorMapping = {
    [FundsStatus.Pending]: 'default',
    [FundsStatus.Received]: 'info',
    [FundsStatus.Allocated]: 'success',
    [FundsStatus.PartiallyAllocated]: 'warning',
    [FundsStatus.Unmatched]: 'error',
    [FundsStatus.Refunded]: 'info',
    [FundsStatus.MatchSuggested]: 'warning',
} as { [key in FundsStatus]: EnumColor };
